/**
 *   Created by ATopcu in 2019
 */
import { fetchAnalyticOptions } from "@ls/grouping-service";
import { exchange } from "@ls/js-fetch";
import SummaryType from "state/selections/Constants/SummaryType";
import SelectionState from "state/selections/SelectionState";
import { selectGetBaseGroupingParams } from "state/selections/selector";
import { splitByCalcType } from "state/util";
import scope from "./scope";
import { selectDefinitions } from "./selectors";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_ANALYTIC_VALUES = `${scope}/REQUEST_ANALYTIC_VALUES`;
export const RECEIVE_ANALYTIC_VALUES = `${scope}/RECEIVE_ANALYTIC_VALUES`;
export const requestAnalyticValues = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_ANALYTIC_VALUES });
    dispatch({
      type: RECEIVE_ANALYTIC_VALUES,
      data: Object.values((await fetchAnalyticOptions()) || {}),
    });
  };
};

export const REQUEST_ANALYTICS_DATA = `${scope}/REQUEST_ANALYTICS_DATA`;
export const RECEIVE_ANALYTICS_DATA = `${scope}/RECEIVE_ANALYTICS_DATA`;
export const REQUEST_ANALYTICS_SBS_DATA = `${scope}/REQUEST_ANALYTICS_SBS_DATA`;
export const RECEIVE_ANALYTICS_SBS_DATA = `${scope}/RECEIVE_ANALYTICS_SBS_DATA`;
export const REQUEST_ANALYTICS_RATIO_DATA = `${scope}/REQUEST_ANALYTICS_RATIO_DATA`;
export const RECEIVE_ANALYTICS_RATIO_DATA = `${scope}/RECEIVE_ANALYTICS_RATIO_DATA`;
export const requestAnalyticsData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    const getBaseGroupingParams = selectGetBaseGroupingParams(state);

    // Separate ratio vs non-ratio definitions
    const nonRatioDefinitions = definitions?.filter(
      (def) => def.scaleType !== "RATIO",
    );
    const ratioDefinitions = definitions?.filter(
      (def) => def.scaleType === "RATIO",
    );

    // Only split non-ratio definitions into abs/rel/bmk
    const [absDefinitions, relDefinitions, bmkDefinitions] =
      splitByCalcType(nonRatioDefinitions);

    const request = async (summary, defs, benchesToo) => {
      dispatch({ type: REQUEST_ANALYTICS_DATA, summary });
      // Compute percentile analytics for the current summary only
      const percentileDefinitionsForSummary = defs.filter(
        ({ scaleType, summary: defSummary }) =>
          ["25", "50", "75", "Median"].includes(scaleType) &&
          defSummary === summary,
      );

      const [params, sbsParams] = getBaseGroupingParams({
        summary,
        benchesToo,
        analytics: [...new Set(defs.map(({ analytic }) => analytic))],
        percentile_analytics: [
          ...new Set(
            percentileDefinitionsForSummary.map(({ analytic }) => analytic),
          ),
        ],
        percentiles: [
          ...new Set(
            percentileDefinitionsForSummary.map(({ scaleType }) =>
              scaleType === "Median" ? "50" : scaleType,
            ),
          ),
        ],
      });
      const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

      dispatch({
        type: RECEIVE_ANALYTICS_DATA,
        summary,
        data: (
          await exchange({
            url,
            params,
            cancelId: `data-${scope}-${summary}`,
          })
        )?.data,
      });

      if (sbsParams) {
        dispatch({ type: REQUEST_ANALYTICS_SBS_DATA, summary });
        dispatch({
          type: RECEIVE_ANALYTICS_SBS_DATA,
          summary,
          data: (
            await exchange({
              url,
              params: sbsParams,
              cancelId: `data-sbs-${scope}-${summary}`,
            })
          )?.data,
        });
      }
    };

    if (absDefinitions.length || bmkDefinitions.length) {
      request(
        SummaryType.ABSOLUTE,
        [...absDefinitions, ...bmkDefinitions],
        bmkDefinitions.length > 0,
      ).then();
    }
    if (relDefinitions.length) {
      request(SummaryType.RELATIVE, relDefinitions, true).then();
    }

    // Make a distinct request for Ratio scaleType definitions and store separately
    const requestRatio = async (defs) => {
      if (!defs?.length) return;
      dispatch({ type: REQUEST_ANALYTICS_RATIO_DATA });
      const [params] = getBaseGroupingParams({
        summary: SummaryType.RELATIVE,
        benchesToo: true,
        analytics: [...new Set(defs.map(({ analytic }) => analytic))],
      });
      params.relative = true;
      params.relativeTypes = "RATIO";
      const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;
      const data = (
        await exchange({
          url,
          params,
          cancelId: `data-ratio-${scope}`,
        })
      )?.data;
      dispatch({ type: RECEIVE_ANALYTICS_RATIO_DATA, data });
    };

    if (ratioDefinitions?.length) {
      requestRatio(ratioDefinitions).then();
    }
  };
};
